import type { MissionsGlobalContext } from '@library/types/missions';
import { createContext } from 'react';

export const MissionsContext = createContext<MissionsGlobalContext>({
  filters: {
    currentPage: 1,
    onCurrentPageChange: () => {}
  },
  isMissionsRequestLoading: false,
  onSelectedMissionId: () => {},
  selectedMissionData: undefined,
  missionsData: undefined
});
